export const MOBILE_SIZE = 768;
const BASE_AMP_URL = `https://amp.`;
export const makeAmpLink = (slug) => `${BASE_AMP_URL}${window.location.hostname}/actualites/${slug}`;
export const FB_API_KEY = '502114410252527';
